import { render } from "./AppProfile.vue?vue&type=template&id=5828c70f&scoped=true"
import script from "./AppProfile.vue?vue&type=script&lang=js"
export * from "./AppProfile.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5828c70f"

export default script